import React, { useEffect, useState } from "react";
import "./footer.scss";
import { graphql, useStaticQuery } from "gatsby";
import { flatListToHierarchical, MenuList } from "./header/utils";
import { sendWcbEvent } from "../functions";
import FacebookLogo from "../assets/logo_facebook.svg";
import InstagramLogo from "../assets/logo_instagram.svg";

const Footer = ({ isHomePage, post }) => {
  //const reCAPTCHA_site_key = "6Lf41ygaAAAAAISMztrLpSFCfZFZ8g3NRhCAy18o";

  const [marginLocalisation, setMarginLocalisation] = useState(0);

  const {
    allWpMenuItemFooter: { nodes: menuFooter },
    allWpMenuItemFooter2: { nodes: menuFooter2 },
    wp: {
      customisationGNRale: {
        acfCustomisation: { logo },
      },
    },
  } = useStaticQuery(graphql`
    query getMenuFooterItems {
      allWpMenuItemFooter: allWpMenuItem(
        filter: { menu: { node: { slug: { in: "menu-footer" } } } }
      ) {
        nodes {
          id
          label
          url
          parent: parentId
        }
      }
      allWpMenuItemFooter2: allWpMenuItem(
        filter: { menu: { node: { slug: { in: "menu-footer-2" } } } }
      ) {
        nodes {
          id
          label
          url
          parent: parentId
        }
      }
      wp {
        customisationGNRale {
          acfCustomisation {
            logo {
              blanc {
                altText
                localFile {
                  childImageSharp {
                    fixed(width: 165, jpegQuality: 10) {
                      src
                    }
                  }
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  `);

  const hierarchicalListFooter = flatListToHierarchical(menuFooter);
  const hierarchicalListFooter2 = flatListToHierarchical(menuFooter2);

  return [
    <footer className="footer" key={1}>
      <section className="menus">
        <div className="inner">
          <div className="copyright">
            <div className="brand-logo">
              {logo?.blanc ? (
                <img
                  src={
                    logo.blanc.localFile.childImageSharp?.fixed?.src ||
                    logo.blanc.localFile.publicURL
                  }
                  alt={logo.blanc.altText || "Normandie Nuisibles"}
                />
              ) : (
                <b>Normandie Nuisibles</b>
              )}
            </div>
            <div className="bottom">
              <div className="socials-footer">
                <span>Suivez-nous : </span>
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/normandie.nuisibles"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={FacebookLogo}
                        alt="Normandie Nuisibles sur Facebook"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/normandie_nuisibles"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={InstagramLogo}
                        alt="Normandie Nuisibles sur Instagram"
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="copyright-text">© Normandie Nuisibles, 2025</div>
            </div>
          </div>
          <div className="footer-columns">
            <div className="footer-column">
              <ul>
                {menuFooter && (
                  <MenuList nodes={hierarchicalListFooter} isFooter={true} />
                )}
              </ul>
            </div>
            <div className="footer-column second">
              <ul>
                {menuFooter2 && (
                  <MenuList nodes={hierarchicalListFooter2} isFooter={true} />
                )}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/*<section className="localisation">
        <div className="inner">
          <div className="logo-normandie">
            <img
              src={logoNormandie}
              alt="Nous intervenons dans toute la Basse-Normandie"
            />
          </div>
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: footer }}
          />
        </div>
      </section>*/}
    </footer>,
    <ExternalScripts key={2} />,
  ];
};

export default Footer;

const ExternalScripts = () => {
  useEffect(() => {
    // add tarteaucitron gtag.js
    if (!document.querySelector(".tarteaucitron-nuisibles")) {
      const scriptNuisibles = document.createElement("script");
      scriptNuisibles.classList.add("tarteaucitron-nuisibles");

      const script = document.createElement("script");

      script.src = "/tarteaucitron/tarteaucitron.js";
      script.async = true;

      script.onload = () => {
        window.tarteaucitron.init({
          privacyUrl: "" /* Privacy policy url */,
          bodyPosition:
            "bottom" /* or top to bring it as first element for accessibility */,
          hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
          cookieName: "tarteaucitron" /* Cookie name */,
          orientation: "middle" /* Banner position (top - bottom) */,
          groupServices: false /* Group services by category */,
          showDetailsOnClick: true /* Click to expand the description */,
          serviceDefaultState: "wait" /* Default state (true - wait - false) */,
          showAlertSmall: false /* Show the small banner on bottom right */,
          cookieslist: false /* Show the cookie list */,
          closePopup: false /* Show a close X on the banner */,
          showIcon: true /* Show cookie icon to manage cookies */,
          //"iconSrc": "", /* Optionnal: URL or base64 encoded image */
          iconPosition:
            "BottomRight" /* BottomRight, BottomLeft, TopRight and TopLeft */,
          adblocker: false /* Show a Warning if an adblocker is detected */,
          DenyAllCta: true /* Show the deny all button */,
          AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
          highPrivacy: true /* HIGHLY RECOMMANDED Disable auto consent */,
          alwaysNeedConsent: false /* Ask the consent for "Privacy by design" services */,
          handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,
          removeCredit: false /* Remove credit link */,
          moreInfoLink: true /* Show more info link */,
          useExternalCss: false /* If false, the tarteaucitron.css file will be loaded */,
          useExternalJs: false /* If false, the tarteaucitron.js file will be loaded */,
          //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */
          readmoreLink: "" /* Change the default readmore link */,
          mandatory: true /* Show a message about mandatory cookies */,
          mandatoryCta: true /* Show the disabled accept button when mandatory on */,
          //"customCloserId": "", /* Optional a11y: Custom element ID used to open the panel */
          googleConsentMode: true /* Enable Google Consent Mode v2 for Google ads and GA4 */,
          partnersList: false /* Show the number of partners on the popup/middle banner */,
        });

        scriptNuisibles.type = "text/javascript";
        scriptNuisibles.text = `window.tarteaucitron.user.gtagUa = 'G-HCRRMMGNDF';

                (window.tarteaucitron.job = window.tarteaucitron.job || []).push('gtag');`;
        (window.tarteaucitron.job = window.tarteaucitron.job || []).push(
          "gcmanalyticsstorage"
        );
        (window.tarteaucitron.job = window.tarteaucitron.job || []).push(
          "gcmadstorage"
        );
        (window.tarteaucitron.job = window.tarteaucitron.job || []).push(
          "gcmadsuserdata"
        );
        (window.tarteaucitron.job = window.tarteaucitron.job || []).push(
          "ahrefs"
        );

        document.body.appendChild(scriptNuisibles);

        window.tarteaucitron.load();
      };

      document.body.appendChild(script);
    }
  }, []);

  return null;
};

/*
const ExternalScripts = ({ reCAPTCHA_site_key }) => {

    useEffect(() => {

        if(!document.querySelector('.recaptcha-nuisibles')) {
            const script = document.createElement("script");
            script.classList.add('recaptcha-nuisibles');
            script.src = `https://www.google.com/recaptcha/api.js?render=${reCAPTCHA_site_key}`;
            script.async = true;
            document.body.appendChild(script);
        }
    }, [reCAPTCHA_site_key]);

    return null;
}*/
